import { Routes } from '@angular/router';
import { EditCultureBioComponent } from './edit-culture-bio/edit-culture-bio.component';
import { ListeCulturesBioComponent } from './liste-cultures-bio/liste-cultures-bio.component';

export const CULTURES_BIO_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const CULTURES_BIO_ROUTES: Routes = [
    { path: '', component: ListeCulturesBioComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditCultureBioComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditCultureBioComponent, data: { roles: ['ORGANISME'] } }
];
